import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { RacingCardsSwiper, RaceSliderWrapper } from './NextRacesSlider.style';
import { RaceSliderItemLoader } from 'src/domains/sportsbook/webview/components/raceSliderItemV1/loader/RaceSliderItemLoader';

export const NextRacesSliderListLoader = observer('NextRacesSliderListLoader', () => {
    return (
        <RaceSliderWrapper key='races-slider-races'>
            <RacingCardsSwiper
                key='slider-swiper'
                inProgress={true}
            >
                {Array.from({ length: 12 }, (_, x) => (
                    <RaceSliderItemLoader key={`placeholder-racing-card-${x}`} />
                ))}
            </RacingCardsSwiper>
        </RaceSliderWrapper>
    );
});
